let xmlRequest = `
<?xml version="1.0" encoding="utf-8"?>
<request>
    <totalPage>总页数, int,必填</totalPage>
    <currentPage>当前页, 从1开始,int, 必填</currentPage>
    <pageSize>每页记录的条数, int, 必填</pageSize>
    <warehouseCode>仓库编码, string (50), 必填</warehouseCode>
    <ownerCode>货主编码, string (50), 必填</ownerCode>
    <checkOrderCode>盘点单编码, string (50), 必填</checkOrderCode>
    <checkOrderId>仓储系统的盘点单编码, string (50), 必填</checkOrderId>
    <checkTime>盘点时间, string(19), string (19), YYYY-MM-DD HH:MM:SS, 必填</checkTime>
    <outBizCode>外部业务编码, string (50), 消息ID, 用于去重，因为网络等原因导致重复传输，请求不会被重复处理</outBizCode>
    <remark>备注, string (500)</remark>
    <documentMaker>制单人, string (50)</documentMaker>
    <updateCode>操作人, string (50)</updateCode>
    <items>
        <item>
            <itemCode>商品编码, string (50), 必填</itemCode>
            <itemId>仓储系统商品ID, string (50), 必填</itemId>
            <inventoryType>质量状态,String(50), ZP=正品, CC=残次, 默认为ZP</inventoryType>
            <virtualWarehouse>虚拟仓库, string (50), 条件必填, 条件为使用虚拟仓库</virtualWarehouse>
            <productDate>商品生产日期, string (10), YYYY-MM-DD</productDate>
            <expireDate>商品过期日期, string (10), YYYY-MM-DD</expireDate>
            <batchCode>批次号, string (50)</batchCode>
            <stockinDate>商品入库日期, string (10), YYYY-MM-DD</stockinDate>
            <userDefined1>自定义批次1, string (50)</userDefined1>
            <userDefined2>自定义批次2, string (50)</userDefined2>
            <userDefined3>自定义批次3, string (50)</userDefined3>
            <userDefined4>自定义批次4, string (50)</userDefined4>
            <quantity>盘盈盘亏商品变化量, float, 必填, 盘盈为正数, 盘亏为负数</quantity>
            <remark>备注, string (500)</remark>
        </item>
    </items>
</request>
`

let xmlResponse = `
<?xml version="1.0" encoding="utf-8"?>
<response>
    <flag>success|failure</flag>
    <code>响应码</code>
    <message>响应信息</message>
</response>
`

let NotificaitonURL = 'NotificaitonURL'

export default { xmlRequest, xmlResponse, NotificaitonURL }



// WEBPACK FOOTER //
// ./src/data/openapi/openapi.inventory.report.js